import type { AirCfarSchedulePriceQuoteRequest } from "@b2bportal/air-cfar-api";
import type { Product, ProductOpaqueValue } from "@b2bportal/purchase-api";
import type {
  CartContext,
  FlightContext,
  FlightPassengerInformationContext,
} from "@checkout/index";
import type { CommonParentContext } from "@checkout/states/common";
import type { ParentState } from "@checkout/types";
import type { CancelForAnyReasonContextV2 } from "./context";

export interface AirCfarProductV2 extends ProductOpaqueValue {
  type: typeof Product.AirCfar;
  value: AirCfarSchedulePriceQuoteRequest;
}

export enum AirCancelForAnyReasonStateV2 {
  route = "route",
  initialize = "initialize",
  addProduct = "addProduct",
  error = "error",
}

/**
 * @deprecated use AirCancelForAnyReasonStateV2
 */
export const CancelForAnyReasonStateV2 = AirCancelForAnyReasonStateV2;

export interface PartialParentContextWithAirCfarV2
  extends CartContext,
    CommonParentContext,
    FlightContext {
  [ParentState.passengerInformation]: FlightPassengerInformationContext;
  [ParentState.cancelForAnyReasonV2]: CancelForAnyReasonContextV2;
}

export interface InitCfarStateEventV2 {
  type: AirCancelForAnyReasonStateV2.initialize;
  state: CancelForAnyReasonContextV2;
}

/**
 * @deprecated use AirCfarEventsV2
 */
export type CfarEventsV2 = InitCfarStateEventV2;

export type AirCfarEventsV2 = InitCfarStateEventV2;
